export const content = {
  tr: {
    seo: {
      title: "MDR Gaming House | Lefkoşa ve Gazimağusa Gaming & E-Spor",
      description: "Lefkoşa ve Gazimağusa’da iki şube: MDR Gaming House. Gaming bilgisayarlarını, saatlik ücretleri, adresleri ve şubeye özel telefon ile WhatsApp bilgilerini keşfet.",
    },
    nav: {
      links: [
        { id: "hakkinda", label: "Hakkında" },
        { id: "neden", label: "Neden MDR?" },
        { id: "oyunlar", label: "Oyunlar" },
        { id: "sistemler", label: "Sistemler" },
        { id: "subeler", label: "Şubeler" },
        { id: "sss", label: "SSS" },
        { id: "iletisim", label: "İletişim" },
      ],
      branchCta: "Konumları Gör",
    },
    hero: {
      eyebrow: "Lefkoşa • Gazimağusa",
      titleLines: ["OYUNUN MERKEZİNE", "HOŞ GELDİN."],
      accentLineIndex: 1,
      subtitle:
        "MDR Gaming House, Kuzey Kıbrıs’ta Lefkoşa ve Gazimağusa olmak üzere iki şubesiyle PC gaming, arkadaşlarla oyun ve e-spor deneyimini bir araya getirir.",
      ctaLefkosa: "Lefkoşa Şubesini Keşfet",
      ctaMagusa: "Gazimağusa Şubesini Keşfet",
      ctaLocations: "Konumları Gör",
      scroll: "Kaydır",
      logoAlt: "MDR Gaming House logo",
    },
    marquee: ["MDR GAMING HOUSE", "LEFKOŞA", "GAZİMAĞUSA", "GAMING", "E-SPOR", "TOPLULUK"],
    about: {
      num: "01",
      label: "MDR Gaming House Nedir?",
      title: "Oyuncunun yerinden tanımlanmış bir gaming house.",
      paragraphs: [
        "MDR Gaming House, Lefkoşa ve Gazimağusa'daki iki şubesiyle gaming, rekabetçi oyunlar ve e-spor kültürünü merkezine alan bir deneyim alanıdır. Burada oyun geçecek bir vakit değil; birlikte büyütülen bir tutkıdır.",
        "Klasik internet kafe kalıbından bilinçli olarak uzak duruyoruz. MDR Gaming House; yüksek performanslı gaming deneyimini, rekabetçi oyuna uygun ortamı ve aynı tutkıyı paylaşan oyuncu topluluğunu tek bir çatı altında birleştirir.",
        "İster tek başına oynamak ister arkadaşlarınla takım halinde sahaya çıkmak isteyin; MDR Gaming House, seni oyunun merkezine odaklandırmak için tasarlandı.",
      ],
      chapters: [
        { num: "01", title: "Gaming Odaklı Yapı", text: "Her detay oyuncunun perspektifinden düşünülür: atmosfer, düzen ve akış gaming için kurgulanır." },
        { num: "02", title: "Rekabetçi Ruh", text: "E-spor ve rekabetçi oyun kültürü, markanın kuruluş fikrinin merkezindedir." },
        { num: "03", title: "Topluluk", text: "Aynı tutkıyı paylaşan oyuncular MDR Gaming House'da bir araya gelir." },
      ],
      stripAlt: "MDR Gaming House'da bilgisayarlarında oyun oynayan oyuncular",
      stripCaption: "Gaming • E-Spor • Topluluk",
    },
    why: {
      num: "02",
      label: "Neden MDR Gaming House?",
      title: "Oyuncu için düşünülmüş altı neden.",
      cards: [
        { icon: "target", title: "Gaming Odaklı Ortam", text: "Oyuncular için tasarlanmış atmosfer; dikkat dağıtan her şey dışarıda bırakılmış bir alan." },
        { icon: "swords", title: "Rekabetçi Oyun Deneyimi", text: "Rekabetçi oyunlara uygun, odaklanmanı destekleyen profesyonel ortam." },
        { icon: "users", title: "Gaming Topluluğu", text: "Oyuncuların bir araya geldiği, oyunun dilinden anlayan sosyal ortam." },
        { icon: "pin", title: "İki Farklı Lokasyon", text: "Lefkoşa ve Gazimağusa'daki MDR Gaming House şubeleriyle her zaman yakındasın." },
        { icon: "armchair", title: "Konforlu Gaming Alanı", text: "Uzun süre oyun oynayan kullanıcıların deneyimini ön planda tutan alanlar." },
        { icon: "shield", title: "Profesyonel Atmosfer", text: "E-spor ve gaming kültürüne uygun, modern ve düzenli bir ortam." },
      ],
    },
    experience: {
      num: "03",
      label: "Gaming Deneyimi",
      title: "MDR Gaming House'da bir gün, oyunun içinde geçer.",
      lead: "PC gaming'den rekabetçi oyunlara, takım halinde oyundan e-spor atmosferine; MDR Gaming House'daki deneyim tek bir başlıkta toplanmaz.",
      imgAlt: "MDR Gaming House'da arkadaşlarla gaming",
      imgCaption: "Takım halinde oyun • Arkadaşlarla gaming",
      items: [
        { title: "PC Gaming", text: "Yüksek performanslı gaming bilgisayarlarıyla akıcı ve kesintisiz oyun deneyimi." },
        { title: "Rekabetçi Oyunlar", text: "Rekabetçi oyun kültürüne uygun, odaklanmaya teşvik eden ortam." },
        { title: "Takım Halinde Oyun", text: "Arkadaşlarınla aynı masada, aynı hedefe dönük oynama keyfi." },
        { title: "Arkadaşlarla Oyun", text: "Sohbetin ve kahkahanın asla geri planda kalmadığı bir alan." },
        { title: "E-Spor Atmosferi", text: "E-spor kültürünü hisseden bir oyun ortamı; sahne havası masalara kadar taşınır." },
        { title: "Gaming Topluluğu", text: "Yanındaki koltuktaki oyuncuyla aynı dili konuştuğun bir topluluk." },
      ],
    },
    games: {
      num: "04",
      label: "Oyunlar",
      title: "Gaming'in farklı türleri, tek çatı altında.",
      lead: "MDR Gaming House, farklı oyun türlerini oynayan geniş bir oyuncu kitlesini düşünerek tasarlandı.",
      note: "Bu bölüm oyun kategorilerini temsili olarak listeler. Kesin oyun listesi doğrulandığında buraya eklenecek.",
      soonLabel: "Oyun listesi yakında eklenecek",
      categories: [
        { icon: "crosshair", name: "FPS", text: "Refleks ve nişancılığın merkezde olduğu rekabetçi tür." },
        { icon: "swords", name: "MOBA", text: "Takım koordinasyonu ve stratejinin ön planda olduğu tür." },
        { icon: "target", name: "Battle Royale", text: "Sahaya tek kişinin bırakıldığı hayatta kalma modu." },
        { icon: "trophy", name: "Sports", text: "Rekabetin dijital sahada başka bir biçimi: spor oyunları." },
        { icon: "flag", name: "Racing", text: "Hızın ve hassas direksiyonun konuşulduğu tür." },
        { icon: "tree", name: "Survival", text: "Kaynak yönetimi ve dayanma becerisinin test edildiği tür." },
        { icon: "users", name: "Co-op", text: "Beraber oynandıkça keyfinin arttığı iş birliği modları." },
      ],
    },
    systems: {
      num: "05",
      label: "Sistemler",
      title: "Gaming Sistemleri & Fiyatlar",
      lead: "Lefkoşa ve Gazimağusa şubelerimizde aynı gaming sistemleriyle oyuna katıl. Donanım özelliklerini ve şubeye özel saatlik ücretleri aşağıda inceleyebilirsin.",
      systemLabels: ["Sistem 1", "Sistem 2"],
      systemsSub: "Her iki şubede geçerli",
      specs: [
        { icon: "gpu", key: "GPU", label: "Grafik İşlemci" },
        { icon: "cpu", key: "CPU", label: "İşlemci" },
        { icon: "ram", key: "RAM", label: "Bellek" },
        { icon: "monitor", key: "MONİTÖR", label: "Monitör" },
        { icon: "wifi", key: "İNTERNET", label: "İnternet" },
      ],
      soon: "Daha sonra eklenecek",
      imgAlt: "Performans odaklı gaming bilgisayarı",
      imgCaption: "Performans odaklı gaming sistemleri",
    },
    pricing: {
      title: "Saatlik Ücretler",
      hour: "saat",
      pc: "PC Kullanımı",
      flat: "tek seferlik",
      soon: "Fiyat yakında eklenecek",
    },
    esports: {
      num: "06",
      label: "E-Spor & Topluluk",
      title: "Burası yalnızca bilgisayar kiralanan bir yer değil.",
      statement:
        "MDR Gaming House; gaming'in, rekabetçi oyunların ve e-spor kültürünün bir parçasıdır.",
      p1: "Burada masa kiralamanın ötesinde, oyunun dilinden anlayan bir topluluğun içinde bulursun kendini. Rekabetçi ruh, takım bilinci ve sürekli gelişim; MDR Gaming House'un kimliğini oluşturan değerlerdir.",
      p2: "Bu kimlik; şubelerimizdeki atmosferde, oyuncularla kurduğumuz ilişkide ve topluluğumuzun duruşunda hissedilir. MDR Gaming House, Lefkoşa ve Gazimağusa'da oyunu ciddiye alanların buluşma noktası olmak için var.",
      upcoming: {
        title: "Turnuvalar & Organizasyonlar",
        text: "MDR Gaming House tarafından düzenlenen turnuva, takım ve organizasyon bilgileri doğrulandığında bu alanda yer alacak.",
        soon: "Bilgi yakında eklenecek",
      },
      videosTitle: "Gazimağusa Şubesinden Görüntüler",
      videosLead: "Gazimağusa şubemizin atmosferini orijinal boyutlarında izle. Sesi açmak için oynatıcıdaki hoparlör simgesine dokun.",
      videos: [
        {
          id: "gazimagusa",
          badge: "GAZİMAĞUSA",
          title: "Gazimağusa Şubesi Editi",
          caption: "Kardeş Sokak’taki Gazimağusa şubemizde RGB atmosferi, geniş PC sıraları ve e-spor ruhu bir arada.",
          src: "/media/venue-video-2.mp4",
          poster: "/media/venue-video-2-poster.jpg",
          width: 576,
          height: 1024,
        },
        {
          id: "lefkosa",
          badge: "GAZİMAĞUSA",
          title: "Gazimağusa Şubesi Atmosferi",
          caption: "Kardeş Sokak’taki Gazimağusa şubemizden gaming ve topluluk görüntüleri.",
          src: "/media/venue-video-1.mp4",
          poster: "/media/venue-video-1-poster.jpg",
          width: 464,
          height: 832,
        },
      ],
      soundOn: "Sesi aç",
      soundOff: "Sesi kapat",
      playVideo: "Videoyu oynat",
      pauseVideo: "Videoyu durdur",
      videoError: "Video yüklenemedi.",
      retryVideo: "Tekrar dene",
    },
    branches: {
      num: "07",
      label: "Şubelerimiz",
      title: "İki şube, aynı tutku.",
      lead: "MDR Gaming House, Kuzey Kıbrıs'ın iki önemli şehrinde hizmet verir: Lefkoşa ve Gazimağusa.",
      mapsBtn: "Google Maps'te Yol Tarifi",
      mapSoon: "Etkileşimli harita yakında eklenecek",
      waBtn: "WhatsApp ile Hızlı Rezervasyon",
      ticketTag: "Şubeye özel",
      waMessage: "Merhaba MDR Gaming House {city}! Rezervasyon yapmak istiyorum.\nTarih: ___\nSaat: ___\nKişi sayısı: ___",
      waFab: {
        label: "WhatsApp ile rezervasyon",
        title: "Hızlı Rezervasyon",
        lead: "Şubeni seç, hazır mesajla tek tıkla WhatsApp'tan yaz.",
        close: "Kapat",
      },
      items: [
        {
          id: "lefkosa",
          city: "Lefkoşa",
          name: "MDR Gaming House – Lefkoşa",
          lines: ["Şehit Ecvet Yusuf Caddesi", "Kızılay 99010", "Lefkoşa"],
          photo: "/img/lefkosa-branch.jpg",
          photoAlt: "MDR Gaming House Lefkoşa (Kızılbaş) şubesi dış cephe",
          mapsUrl:
            "https://www.google.com/maps/search/?api=1&query=MDR%20Gaming%20House%20%C5%9Eehit%20Ecvet%20Yusuf%20Caddesi%20K%C4%B1z%C4%B1lay%2099010%20Lefko%C5%9Fa",
        },
        {
          id: "gazimagusa",
          city: "Gazimağusa",
          name: "MDR Gaming House – Gazimağusa",
          lines: ["Kardeş Sk", "Gazimağusa 99450"],
          photo: "/img/gazimagusa-branch.jpg",
          photoAlt: "MDR Gaming House Gazimağusa şubesi dış cephe",
          mapsUrl:
            "https://www.google.com/maps/search/?api=1&query=MDR%20Gaming%20House%20Karde%C5%9F%20Sk%20Gazima%C4%9Fusa%2099450",
        },
      ],
    },
    prefer: {
      num: "08",
      label: "Neden MDR Gaming House?",
      title: "Lefkoşa ve Gazimağusa’da gaming için MDR.",
      blocks: [
        {
          h3: "Lefkoşa’da gaming house arayanlar için",
          paragraphs: ["MDR Gaming House Lefkoşa şubesi, Şehit Ecvet Yusuf Caddesi, Kızılay 99010 adresindedir. Lefkoşa’da internet kafe veya PC gaming alanı arıyorsan, şubenin bilgisayar sistemlerini ve saatlik ücretini bu sayfada inceleyebilir, konum kartından yol tarifi alabilirsin."],
        },
        {
          h3: "Gazimağusa’da oyun ve e-spor buluşma noktası",
          paragraphs: ["MDR Gaming House’un Gazimağusa (Mağusa) şubesi Kardeş Sokak, Gazimağusa 99450 adresindedir. Mağusa’da arkadaşlarınla bilgisayar oyunu oynamak veya rekabetçi oyun deneyimi yaşamak için bu şubeyi değerlendirebilirsin. Gazimağusa’ya ait fiyat ve iletişim bilgileri Lefkoşa’dan ayrı gösterilir."],
        },
        {
          h3: "Tercih etmeden önce donanımı ve fiyatı gör",
          paragraphs: ["Bir gaming house seçerken işlemci, ekran kartı, bellek ve monitör bilgilerini karşılaştırmak önemlidir. MDR’nin iki şubede kullanılan ortak sistem özelliklerini Sistemler ve Fiyatlar bölümünde bulabilirsin. Saatlik ücretler şubeye göre ayrı listelenir; böylece gitmeden önce hangi donanımı ve ücreti değerlendirdiğini bilirsin."],
        },
        {
          h3: "Tek başına veya arkadaşlarınla PC gaming",
          paragraphs: ["MDR Gaming House yalnızca bilgisayar kullanabileceğin bir yer olarak değil, oyuncuların bir araya geldiği bir gaming ve e-spor ortamı olarak konumlanır. Tek başına oyun oynamak, arkadaşlarınla aynı ortamı paylaşmak veya takım hâlinde rekabetçi oyunlara katılmak isteyen oyunculara hitap eder. Kesin oyun listesi ve turnuva duyuruları doğrulandığında sitede paylaşılır."],
        },
        {
          h3: "İki şube, doğrudan iletişim",
          paragraphs: ["Lefkoşa ve Gazimağusa farklı şubelerdir; ulaşmak istediğin şubeyi seçerek o şubenin telefon veya WhatsApp alanını kullanabilirsin. Adresler ve yol tarifi bağlantıları Şubelerimiz bölümünde, şubeye özel iletişim bilgileri ise İletişim bölümünde yer alır."],
        },
      ],
    },
    faq: {
      num: "09",
      label: "Sık Sorulan Sorular",
      title: "Merak edilenler.",
      pendingText: "Bu bilgi yakında güncellenecektir.",
      items: [
        {
          q: "MDR Gaming House nerede?",
          a: ["MDR Gaming House, Kuzey Kıbrıs'ta iki şubeyle hizmet verir: biri Lefkoşa'da, biri Gazimağusa'da."],
        },
        {
          q: "MDR Gaming House Lefkoşa'da nerede?",
          a: [
            "Lefkoşa şubemiz Şehit Ecvet Yusuf Caddesi, Kızılay 99010 adresinde yer alır. Yol tarifi için şubeler bölümündeki Google Maps butonunu kullanabilirsin.",
          ],
        },
        {
          q: "MDR Gaming House Gazimağusa'da nerede?",
          a: [
            "Gazimağusa şubemiz Kardeş Sk, Gazimağusa 99450 adresinde yer alır. Yol tarifi için şubeler bölümündeki Google Maps butonunu kullanabilirsin.",
          ],
        },
        {
          q: "MDR Gaming House internet kafe mi?",
          a: [
            "MDR Gaming House, klasik anlamda bir internet kafeden çok daha fazlasıdır. Gaming, rekabetçi oyunlar ve e-spor kültürüne odaklanan bir gaming house'tur.",
          ],
        },
        {
          q: "MDR Gaming House'da gaming bilgisayarları var mı?",
          a: [
            "Evet. MDR Gaming House, yüksek performanslı gaming bilgisayarları merkezinde tasarlanmış bir gaming deneyim alanıdır. İki şubemizin donanım özelliklerini Sistemler bölümünde inceleyebilirsin.",
          ],
        },
        {
          q: "MDR Gaming House e-spor için uygun mu?",
          a: [
            "MDR Gaming House, e-spor ve rekabetçi oyun kültürünü merkezine alan bir markadır. Rekabetçi oyuna uygun bir ortam sunmak için tasarlanmıştır.",
          ],
        },
        { q: "MDR Gaming House'da hangi oyunlar oynanıyor?", a: [] },
        { q: "MDR Gaming House çalışma saatleri nedir?", source: "hours", a: [] },
        { q: "Bilgisayar sistemleri nelerdir?", source: "systems", a: [] },
        { q: "Lefkoşa ve Gazimağusa şubelerinin saatlik ücretleri nedir?", source: "prices", a: [] },
        { q: "Lefkoşa veya Mağusa’da neden MDR Gaming House tercih edilebilir?", a: ["MDR Gaming House, iki şehirde şube seçeneği, açıkça listelenen bilgisayar özellikleri ve şubeye özel saatlik ücretleriyle PC gaming alanı arayan oyuncuların değerlendirebileceği bir işletmedir. Donanımı, adresi ve ücreti bu sayfadan karşılaştırarak sana uygun şubeyi seçebilirsin."] },
        { q: "Şubelerin telefon ve WhatsApp bilgilerine nasıl ulaşırım?", a: ["İletişim bölümünde Lefkoşa ve Gazimağusa için ayrı telefon ve WhatsApp alanları bulunur. Ulaşmak istediğin şubeyi seç; numarası yayımlandığında telefon veya WhatsApp bağlantısını doğrudan kullanabilirsin."] },
      ],
    },
    contact: {
      num: "10",
      label: "İletişim",
      title: "Şubene doğrudan ulaş.",
      lead: "Lefkoşa ve Gazimağusa için ayrı telefon ve WhatsApp alanları. Ulaşmak istediğin şubenin bilgilerini seç; ortak sosyal medya hesaplarımızı da buradan takip edebilirsin.",
      channels: [
        { icon: "phone", label: "Telefon" },
        { icon: "instagram", label: "Instagram" },
        { icon: "facebook", label: "Facebook" },
        { icon: "mail", label: "E-posta" },
        { icon: "whatsapp", label: "WhatsApp" },
      ],
      soon: "Bilgi yakında eklenecek",
      branchTitle: "Şubelerimiz",
    },
    footer: {
      cities: "Lefkoşa • Gazimağusa",
      tagline: "Gaming • E-Spor • Topluluk",
      navTitle: "Keşfet",
      socials: ["Instagram", "Facebook"],
      socialSoon: "Yakında eklenecek",
      rights: "Tüm hakları saklıdır.",
      brandLine: "MDR Gaming House",
    },
  },
  en: {
    seo: {
      title: "MDR Gaming House | Gaming & Esports in Lefkoşa and Gazimağusa",
      description: "Explore MDR Gaming House in Lefkoşa and Gazimağusa, Northern Cyprus. Compare gaming systems, hourly rates, addresses and each branch’s phone and WhatsApp details.",
    },
    nav: {
      links: [
        { id: "hakkinda", label: "About" },
        { id: "neden", label: "Why MDR?" },
        { id: "oyunlar", label: "Games" },
        { id: "sistemler", label: "Systems" },
        { id: "subeler", label: "Branches" },
        { id: "sss", label: "FAQ" },
        { id: "iletisim", label: "Contact" },
      ],
      branchCta: "View Locations",
    },
    hero: {
      eyebrow: "Lefkoşa • Gazimağusa",
      titleLines: ["WELCOME TO THE", "CENTER OF THE GAME."],
      accentLineIndex: 1,
      subtitle:
        "MDR Gaming House brings together PC gaming, playing with friends and esports at two branches in Northern Cyprus: Lefkoşa and Gazimağusa.",
      ctaLefkosa: "Explore the Lefkoşa Branch",
      ctaMagusa: "Explore the Gazimağusa Branch",
      ctaLocations: "View Locations",
      scroll: "Scroll",
      logoAlt: "MDR Gaming House logo",
    },
    marquee: ["MDR GAMING HOUSE", "LEFKOŞA", "GAZİMAĞUSA", "GAMING", "E-SPORTS", "COMMUNITY"],
    about: {
      num: "01",
      label: "What is MDR Gaming House?",
      title: "A gaming house, defined from the player's seat.",
      paragraphs: [
        "With its two branches in Lefkoşa and Gazimağusa, MDR Gaming House is an experience space built around gaming, competitive play and e-sports culture. Here, gaming is not time to pass — it is a passion grown together.",
        "We deliberately step away from the classic internet cafe template. MDR Gaming House brings a high-performance gaming experience, an environment suited to competitive play and a community of players who share the same passion under one roof.",
        "Whether you want to play on your own or hit the field with your friends as a team, MDR Gaming House is designed to keep you focused on the center of the game.",
      ],
      chapters: [
        { num: "01", title: "Gaming-Focused Structure", text: "Every detail is considered from the player's perspective: atmosphere, layout and flow are designed for gaming." },
        { num: "02", title: "Competitive Spirit", text: "E-sports and competitive gaming culture sit at the core of the brand's founding idea." },
        { num: "03", title: "Community", text: "Players who share the same passion come together at MDR Gaming House." },
      ],
      stripAlt: "Players gaming at their computers at MDR Gaming House",
      stripCaption: "Gaming • E-Sports • Community",
    },
    why: {
      num: "02",
      label: "Why MDR Gaming House?",
      title: "Six reasons, designed around the player.",
      cards: [
        { icon: "target", title: "Gaming-Focused Environment", text: "An atmosphere designed for players — a space where distractions are left at the door." },
        { icon: "swords", title: "Competitive Play Experience", text: "A professional setting suited to competitive games that supports your focus." },
        { icon: "users", title: "Gaming Community", text: "A social space where players come together and speak the language of gaming." },
        { icon: "pin", title: "Two Distinct Locations", text: "With MDR Gaming House branches in Lefkoşa and Gazimağusa, you are always close." },
        { icon: "armchair", title: "Comfortable Gaming Areas", text: "Spaces that put the experience of long gaming sessions first." },
        { icon: "shield", title: "Professional Atmosphere", text: "A modern, orderly environment in line with e-sports and gaming culture." },
      ],
    },
    experience: {
      num: "03",
      label: "Gaming Experience",
      title: "A day at MDR Gaming House is spent inside the game.",
      lead: "From PC gaming to competitive play, from team sessions to the e-sports atmosphere — the experience at MDR Gaming House does not fit into a single headline.",
      imgAlt: "Gaming with friends at MDR Gaming House",
      imgCaption: "Team play • Gaming with friends",
      items: [
        { title: "PC Gaming", text: "A fluid, uninterrupted gaming experience on high-performance gaming computers." },
        { title: "Competitive Games", text: "An environment aligned with competitive gaming culture that encourages focus." },
        { title: "Playing as a Team", text: "The joy of playing at the same table with your friends, toward the same goal." },
        { title: "Gaming with Friends", text: "A space where conversation and laughter are never in the background." },
        { title: "E-Sports Atmosphere", text: "A gaming environment that feels e-sports — the stage vibe travels all the way to the desk." },
        { title: "Gaming Community", text: "A community where the player in the next seat speaks your language." },
      ],
    },
    games: {
      num: "04",
      label: "Games",
      title: "Every side of gaming, under one roof.",
      lead: "MDR Gaming House is designed with a broad community of players of many game genres in mind.",
      note: "This section lists game categories as a representation. The confirmed game list will be added here once verified.",
      soonLabel: "Game list to be added soon",
      categories: [
        { icon: "crosshair", name: "FPS", text: "A competitive genre where reflexes and marksmanship take center stage." },
        { icon: "swords", name: "MOBA", text: "A genre defined by team coordination and strategy." },
        { icon: "target", name: "Battle Royale", text: "A survival mode where only one player is left standing." },
        { icon: "trophy", name: "Sports", text: "Competition in another digital form: sports games." },
        { icon: "flag", name: "Racing", text: "A genre built on speed and precise steering." },
        { icon: "tree", name: "Survival", text: "A genre that tests resource management and endurance." },
        { icon: "users", name: "Co-op", text: "Cooperative modes that get better the more you play together." },
      ],
    },
    systems: {
      num: "05",
      label: "Systems",
      title: "Gaming Systems & Prices",
      lead: "Play on the same gaming systems at our Lefkoşa and Gazimağusa branches. Explore the hardware specifications and each branch's hourly rates below.",
      systemLabels: ["System 1", "System 2"],
      systemsSub: "Available at both branches",
      specs: [
        { icon: "gpu", key: "GPU", label: "Graphics Card" },
        { icon: "cpu", key: "CPU", label: "Processor" },
        { icon: "ram", key: "RAM", label: "Memory" },
        { icon: "monitor", key: "MONITOR", label: "Monitor" },
        { icon: "wifi", key: "INTERNET", label: "Internet" },
      ],
      soon: "To be added soon",
      imgAlt: "Performance-focused gaming computer",
      imgCaption: "Performance-focused gaming systems",
    },
    pricing: {
      title: "Hourly Rates",
      hour: "hour",
      pc: "PC Usage",
      flat: "one-time",
      soon: "Price to be added soon",
    },
    esports: {
      num: "06",
      label: "E-Sports & Community",
      title: "This is not just a place to rent a computer.",
      statement: "MDR Gaming House is part of gaming, competitive play and e-sports culture.",
      p1: "Beyond renting a desk, you find yourself inside a community that speaks the language of gaming. Competitive spirit, team awareness and continuous improvement are the values that form MDR Gaming House's identity.",
      p2: "That identity is felt in the atmosphere of our branches, in the way we relate to players and in the stance of our community. MDR Gaming House exists to be the meeting point of those who take gaming seriously, in Lefkoşa and Gazimağusa.",
      upcoming: {
        title: "Tournaments & Events",
        text: "Information about tournaments, teams and events organized by MDR Gaming House will appear here once verified.",
        soon: "To be added soon",
      },
      videosTitle: "Footage from Our Gazimağusa Branch",
      videosLead: "Watch the atmosphere of our Gazimağusa branch in its original dimensions. Tap the speaker icon on a player to unmute.",
      videos: [
        {
          id: "gazimagusa",
          badge: "GAZİMAĞUSA",
          title: "Gazimağusa Branch Edit",
          caption: "RGB ambient lighting, spacious PC rows and an authentic esports vibe at our Gazimağusa branch on Kardeş Street.",
          src: "/media/venue-video-2.mp4",
          poster: "/media/venue-video-2-poster.jpg",
          width: 576,
          height: 1024,
        },
        {
          id: "lefkosa",
          badge: "GAZİMAĞUSA",
          title: "Gazimağusa Branch Atmosphere",
          caption: "Gaming and community footage from our Gazimağusa branch on Kardeş Street.",
          src: "/media/venue-video-1.mp4",
          poster: "/media/venue-video-1-poster.jpg",
          width: 464,
          height: 832,
        },
      ],
      soundOn: "Unmute",
      soundOff: "Mute",
      playVideo: "Play video",
      pauseVideo: "Pause video",
      videoError: "The video could not be loaded.",
      retryVideo: "Try again",
    },
    branches: {
      num: "07",
      label: "Our Branches",
      title: "Two branches, one passion.",
      lead: "MDR Gaming House serves in two major cities of Northern Cyprus: Lefkoşa and Gazimağusa.",
      mapsBtn: "Get Directions on Google Maps",
      mapSoon: "Interactive map to be added soon",
      waBtn: "Quick Booking via WhatsApp",
      ticketTag: "Branch exclusive",
      waMessage: "Hi MDR Gaming House {city}! I'd like to make a booking.\nDate: ___\nTime: ___\nNumber of people: ___",
      waFab: {
        label: "Book via WhatsApp",
        title: "Quick Booking",
        lead: "Pick your branch and message us on WhatsApp with a ready-made text.",
        close: "Close",
      },
      items: [
        {
          id: "lefkosa",
          city: "Lefkoşa",
          name: "MDR Gaming House – Lefkoşa",
          lines: ["Şehit Ecvet Yusuf Caddesi", "Kızılay 99010", "Lefkoşa"],
          photo: "/img/lefkosa-branch.jpg",
          photoAlt: "MDR Gaming House Lefkoşa (Kızılbaş) branch storefront",
          mapsUrl:
            "https://www.google.com/maps/search/?api=1&query=MDR%20Gaming%20House%20%C5%9Eehit%20Ecvet%20Yusuf%20Caddesi%20K%C4%B1z%C4%B1lay%2099010%20Lefko%C5%9Fa",
        },
        {
          id: "gazimagusa",
          city: "Gazimağusa",
          name: "MDR Gaming House – Gazimağusa",
          lines: ["Kardeş Sk", "Gazimağusa 99450"],
          photo: "/img/gazimagusa-branch.jpg",
          photoAlt: "MDR Gaming House Gazimağusa şubesi dış cephe",
          mapsUrl:
            "https://www.google.com/maps/search/?api=1&query=MDR%20Gaming%20House%20Karde%C5%9F%20Sk%20Gazima%C4%9Fusa%2099450",
        },
      ],
    },
    prefer: {
      num: "08",
      label: "Why MDR Gaming House?",
      title: "Gaming in Lefkoşa and Gazimağusa, with MDR.",
      blocks: [
        {
          h3: "Looking for a gaming house in Lefkoşa?",
          paragraphs: ["MDR Gaming House’s Lefkoşa branch is on Şehit Ecvet Yusuf Caddesi, Kızılay 99010. If you are looking for an internet cafe or PC gaming space in Lefkoşa, explore the branch’s computer systems and hourly rate on this page, then use the location card for directions."],
        },
        {
          h3: "Gaming and esports in Gazimağusa",
          paragraphs: ["The Gazimağusa (Mağusa / Famagusta) branch of MDR Gaming House is on Kardeş Sokak, Gazimağusa 99450. It is an option for playing PC games with friends and enjoying competitive gaming in Mağusa. Gazimağusa’s prices and contact details are listed separately from Lefkoşa’s."],
        },
        {
          h3: "Compare the hardware and price before you visit",
          paragraphs: ["The processor, graphics card, memory and monitor are useful details when choosing a gaming house. Find the shared hardware specifications for both MDR branches in Systems & Prices. Hourly rates are listed by branch so you can see which equipment and price you are considering before visiting."],
        },
        {
          h3: "PC gaming on your own or with friends",
          paragraphs: ["MDR Gaming House is positioned as a gaming and esports space where players come together, not simply a place to use a computer. It welcomes solo players, friends sharing the same space and teams interested in competitive games. The confirmed game list and tournament announcements will be shared on the site when available."],
        },
        {
          h3: "Two branches, direct contact",
          paragraphs: ["Lefkoşa and Gazimağusa are separate branches. Select the branch you want to reach and use its phone or WhatsApp details. Addresses and directions are in Our Branches; branch-specific contact details are in Contact."],
        },
      ],
    },
    faq: {
      num: "09",
      label: "Frequently Asked Questions",
      title: "Good to know.",
      pendingText: "This information will be updated soon.",
      items: [
        {
          q: "Where is MDR Gaming House?",
          a: ["MDR Gaming House serves in two branches in Northern Cyprus: one in Lefkoşa and one in Gazimağusa."],
        },
        {
          q: "Where is MDR Gaming House in Lefkoşa?",
          a: [
            "Our Lefkoşa branch is located at Şehit Ecvet Yusuf Caddesi, Kızılay 99010. You can use the Google Maps button in the branches section for directions.",
          ],
        },
        {
          q: "Where is MDR Gaming House in Gazimağusa?",
          a: [
            "Our Gazimağusa branch is located at Kardeş Sk, Gazimağusa 99450. You can use the Google Maps button in the branches section for directions.",
          ],
        },
        {
          q: "Is MDR Gaming House an internet cafe?",
          a: [
            "MDR Gaming House is much more than a classic internet cafe. It is a gaming house focused on gaming, competitive play and e-sports culture.",
          ],
        },
        {
          q: "Does MDR Gaming House have gaming computers?",
          a: [
            "Yes. MDR Gaming House is a gaming experience space designed around high-performance gaming computers. Explore the hardware specifications for both branches in our Systems section.",
          ],
        },
        {
          q: "Is MDR Gaming House suitable for e-sports?",
          a: [
            "MDR Gaming House is a brand built around e-sports and competitive gaming culture. It is designed to offer an environment suited to competitive play.",
          ],
        },
        { q: "Which games can be played at MDR Gaming House?", a: [] },
        { q: "What are MDR Gaming House's opening hours?", source: "hours", a: [] },
        { q: "What are the computer systems like?", source: "systems", a: [] },
        { q: "What are the hourly rates at the Lefkoşa and Gazimağusa branches?", source: "prices", a: [] },
        { q: "Why consider MDR Gaming House in Lefkoşa or Mağusa?", a: ["MDR Gaming House is an option for PC gaming with branches in two cities, published computer specifications and separate hourly rates. Compare the hardware, address and price on this page to choose the branch that suits you."] },
        { q: "How can I find each branch’s phone and WhatsApp details?", a: ["The Contact section has separate phone and WhatsApp fields for Lefkoşa and Gazimağusa. Choose the branch you want to reach; once its number is published, use its phone or WhatsApp link directly."] },
      ],
    },
    contact: {
      num: "10",
      label: "Contact",
      title: "Reach your branch directly.",
      lead: "Separate phone and WhatsApp details for Lefkoşa and Gazimağusa. Choose the branch you want to reach, or follow our shared social media accounts below.",
      channels: [
        { icon: "phone", label: "Phone" },
        { icon: "instagram", label: "Instagram" },
        { icon: "facebook", label: "Facebook" },
        { icon: "mail", label: "E-mail" },
        { icon: "whatsapp", label: "WhatsApp" },
      ],
      soon: "To be added soon",
      branchTitle: "Our Branches",
    },
    footer: {
      cities: "Lefkoşa • Gazimağusa",
      tagline: "Gaming • E-Sports • Community",
      navTitle: "Explore",
      socials: ["Instagram", "Facebook"],
      socialSoon: "Coming soon",
      rights: "All rights reserved.",
      brandLine: "MDR Gaming House",
    },
  },
};
